import {
    ADD_CSS,
    ADD_CSS_FAIL,
    ADD_CSS_START,
    ADD_CSS_SUCCESS,
    DELETE_CSS,
    DELETING_CSS,
    DELETING_CSS_FAIL,
    DELETING_CSS_SUCCESS,
    FETCH_CSS_RANGE_DATA,
    FETCH_CSS_RANGE_DATA_ERROR,
    FETCH_CSS_RANGE_DATA_FETCHING,
    FETCH_CSS_RANGE_DATA_SUCCESS,
    FETCH_LATEST_CSS,
    FETCH_LATEST_CSS_FAIL,
    FETCH_LATEST_CSS_FETCHING,
    FETCH_LATEST_CSS_SUCCESS
} from '../../actions/criticalSwimSpeedActions';

const INITIAL_STATE = {
    latestCSS: {},
    isLatestCSSFetching: false,
    didLatestCSSFetchFail: false,
    cssReportData: [],
    cssReportDataFetching: false,
    cssReportDataFetchFail: false,
    addCSSFetching: false,
    deleteCSSFetching: false,
    deleteCSSFail: false
};

// ======= Fetching Handlers =======
const fetchLatestCSSFetching = (state) => ({
    ...state,
    isLatestCSSFetching: true
});

const fetchLatestCSSSuccess = (state, action) => ({
    ...state,
    latestCSS: action.latestCSS,
    isLatestCSSFetching: false,
    didLatestCSSFetchFail: false
});

const fetchLatestCSSFail = (state) => ({
    ...state,
    isLatestCSSFetching: false,
    didLatestCSSFetchFail: true
});

const fetchCssRangeDataSuccess = (state, action) => {
    return {
        cssReportData: action.data,
        cssReportDataFetching: false,
        cssReportDataFetchFail: false
    };
};

const fetchCssRangeDataFail = (state) => {
    return {
        ...state,
        cssReportDataFetchFail: true,
        cssReportDataFetching: false
    };
};

const fetchCssRangeDataFetching = (state) => {
    return {
        ...state,
        cssReportDataFetching: true
    };
};

const addCSSStart = (state) => ({
    ...state,
    addCSSFetching: true
});

const addCSSFinish = (state) => ({
    ...state,
    addCSSFetching: false
});

const deleteCSSStart = (state) => ({
    ...state,
    deleteCSSFetching: true,
    deleteCSSFail: false
});

const deleteCSSSuccess = (state) => ({
    ...state,
    deleteCSSFetching: false,
    deleteCSSFail: false
});

const deleteCSSFail = (state) => ({
    ...state,
    deleteCSSFetching: false,
    deleteCSSFail: true
});

// ======= Handler Assignments =======
const handlers = {
    [FETCH_LATEST_CSS_FETCHING]: fetchLatestCSSFetching,
    [FETCH_LATEST_CSS_SUCCESS]: fetchLatestCSSSuccess,
    [FETCH_LATEST_CSS_FAIL]: fetchLatestCSSFail,
    [FETCH_CSS_RANGE_DATA_ERROR]: fetchCssRangeDataFail,
    [FETCH_CSS_RANGE_DATA_FETCHING]: fetchCssRangeDataFetching,
    [FETCH_CSS_RANGE_DATA_SUCCESS]: fetchCssRangeDataSuccess,
    [ADD_CSS_START]: addCSSStart,
    [ADD_CSS_SUCCESS]: addCSSFinish,
    [ADD_CSS_FAIL]: addCSSFinish,
    [DELETING_CSS]: deleteCSSStart,
    [DELETING_CSS_SUCCESS]: deleteCSSSuccess,
    [DELETING_CSS_FAIL]: deleteCSSFail
};

// ======= Default Action ======
export default function cssReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchLatestCSS(payload, evictCache) {
    return {
        payload,
        type: FETCH_LATEST_CSS,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function fetchCssReportData(startDate, endDate, aggregation) {
    return {
        type: FETCH_CSS_RANGE_DATA,
        startDate: startDate,
        endDate: endDate,
        aggregation: aggregation
    };
}

export function addCSS(payload, actionToDispatch) {
    return {
        type: ADD_CSS,
        payload: payload,
        actionToDispatch: actionToDispatch
    };
}

export function deleteCSSEntry(cssValue, callback) {
    return {
        type: DELETE_CSS,
        cssValue,
        callback
    };
}

// ======= Selectors =======
export const getLatestCSS = (state) => {
    return state.cssReports.latestCSS ? state.cssReports.latestCSS : null;
};

export const isLatestCSSFetching = (state) => {
    return state.cssReports.isLatestCSSFetching;
};

export const isLatestCSSFetchFail = (state) => {
    return state.cssReports.didLatestCSSFetchFail;
};

export function getCssData(state) {
    return state.cssReports.cssReportData;
}

export const isAddCSSInProgress = (state) => {
    return state.cssReports.addCSSFetching;
};

export const isDeleteCSSInProgress = (state) => {
    return state.cssReports.deleteCSSFetching;
};

export const isDeletingCSSFail = (state) => {
    return state.cssReports.deleteCSSFail;
};
